import React from "react";

import { Layout } from "./src/components/layout";
import { storeClickIds } from "./src/lib/utils/click-ids";

export const onClientEntry = () => {
    storeClickIds();
};

export const wrapPageElement = ({ element, props }) => {
    return (
        <>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
            <link href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap" rel="stylesheet" />
            
            <Layout haveLayout={true}>
                {element}
            </Layout>
        </>
    );
};

export const shouldUpdateScroll = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
  return false;
};